const DUPLICATE_WINDOW_MS = 60 * 1000;

export const deduplicateReflections = (reflections = []) => {
  const accepted = [];

  return reflections.filter((reflection) => {
    const creatorId = reflection.createdBy?._id || reflection.createdBy || "";
    const text = reflection.text?.trim() || "";
    const createdAt = new Date(reflection.createdAt).getTime();
    const duplicate = accepted.some(
      (existing) =>
        existing.creatorId.toString() === creatorId.toString() &&
        existing.text === text &&
        Number.isFinite(createdAt) &&
        Number.isFinite(existing.createdAt) &&
        Math.abs(existing.createdAt - createdAt) <= DUPLICATE_WINDOW_MS
    );

    if (!duplicate) accepted.push({ creatorId, text, createdAt });
    return !duplicate;
  });
};
